import type { ComputedRef } from 'vue'

import type { ApprovalStage } from '@/types/workflow'
import { getHistoricalMaxStage } from '@/utils/workflowPresentation'

export function useWorkspacePageHelpers(options: {
  currentStage: ComputedRef<ApprovalStage>
  customerPhases: ComputedRef<Array<{ key: ApprovalStage; status: string }>>
  pendingApprovalStage: ComputedRef<ApprovalStage | null>
  workflow: ComputedRef<{ data?: { historical_max_stage?: ApprovalStage } } | null>
}) {
  function stageStatus(stage: ApprovalStage) {
    return options.customerPhases.value.find((item) => item.key === stage)?.status || 'pending'
  }

  function getActionErrorMessage(error: any): string | null {
    const detail = error?.response?.data?.detail
    if (typeof detail === 'string' && detail.trim()) {
      return detail
    }
    const message = error?.response?.data?.message
    if (typeof message === 'string' && message.trim()) {
      return message
    }
    return null
  }

  function canInspectPhase(stage: ApprovalStage, status: string) {
    const stageOrder: ApprovalStage[] = ['proposal', 'script', 'storyboard', 'final']
    const historicalIndex = stageOrder.indexOf(getHistoricalMaxStage(options.workflow.value as any))
    const stageIndex = stageOrder.indexOf(stage)

    if (options.pendingApprovalStage.value === stage) {
      return true
    }

    if (stageIndex !== -1 && historicalIndex !== -1 && stageIndex <= historicalIndex) {
      return true
    }

    return status === 'completed' || status === 'review' || options.currentStage.value === stage
  }

  function scrollWorkspaceToTop() {
    if (typeof window === 'undefined') {
      return
    }
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return {
    canInspectPhase,
    getActionErrorMessage,
    scrollWorkspaceToTop,
    stageStatus,
  }
}